import React from "react";
import {Route} from "react-router-dom";
import DocumentListPage from "../resources/DocumentListPage";
import InvoiceDetailsPage from "../resources/Invoices/pages/InvoiceDetailsPage";
import CreateInvoicePage from "../resources/Invoices/pages/CreateInvoicePage";
import ResubmitInvoicePage from "../resources/Invoices/pages/ResubmitInvoicePage";
import CreditNoteDetailsPage from "../resources/creditNotes/pages/CreditNoteDetailsPage";
import CreateCreditNotePage from "../resources/creditNotes/pages/CreateCreditNotePage";
import ResubmitCreditNotePage from "../resources/creditNotes/pages/ResubmitCreditNotePage";
import BusinessProfileListPage from "../resources/businessProfiles/pages/BusinessProfileListPage";
import BusinessProfileDetailsPage from "../resources/businessProfiles/pages/BusinessProfileDetailsPage";
import CreateBusinessProfilePage from "../resources/businessProfiles/pages/CreateBusinessProfilePage";
import EditBusinessProfilePage from "../resources/businessProfiles/pages/EditBusinessProfilePage";
import CustomerListPage from "../resources/customers/pages/CustomerListPage";
import CustomerDetailsPage from "../resources/customers/pages/CustomerDetailsPage";
import EditCustomerPage from "../resources/customers/pages/EditCustomerPage";
import CreateCustomersPage from "../resources/customers/pages/CreateCustomersPage";
import SupplierListPage from "../resources/suppliers/pages/SupplierListPage";
import SupplierDetailsPage from "../resources/suppliers/pages/SupplierDetailsPage";
import EditSupplierPage from "../resources/suppliers/pages/EditSupplierPage";
import CreateSuppliersPage from "../resources/suppliers/pages/CreateSuppliersPage";
import SettingsPage from "../resources/settings/pages/SettingsPage";
import DocumentReportPage from "../resources/documentReports/pages/DocumentReportPage";
import VATReportPage from "../resources/documentReports/pages/VATReportPage";
import BulkUploadListPage from "../resources/bulkUpload/pages/BulkUploadListPage";
import ProductListPage from "../resources/products/pages/ProductListPage";
import DashboardPage from "../resources/dashboard/pages/dashboardPage";
import BusinessProfileAccessLayout from "../resources/businessProfiles/components/BusinessProfileAccessLayout";
import PurchaseDocumentsAccessLayout from "../resources/Invoices/components/PurchaseDocumentsAccessLayout";
import SalesDocumentsAccessLayout from "../resources/Invoices/components/SalesDocumentsAccessLayout";
import SupplierAccessLayout from "../resources/suppliers/components/SupplierAccessLayout";
import CustomerAccessLayout from "../resources/customers/components/CustomerAccessLayout";
import PurchaseInvoiceReadLayout from "../resources/Invoices/components/PurchaseInvoiceReadLayout";
import SalesCreditNoteReadLayout from "../resources/creditNotes/components/SalesCreditNoteReadLayout";
import SalesInvoiceReadLayout from "../resources/Invoices/components/SalesInvoiceReadLayout";
import PurchaseCreditNoteReadLayout from "../resources/creditNotes/components/PurchaseCreditNoteReadLayout";
import ProductAccessLayout from "../resources/products/components/ProductAccessLayout";
import DocumentReportAccessLayout from "../resources/documentReports/components/DocumentReportAccessLayout";
import VATReportAccessLayout from "../resources/documentReports/components/VATReportAccessLayout";
import DashboardAccessLayout from "../resources/dashboard/components/DashboardAccessLayout";


import BulkUploadAccessLayout from "../resources/bulkUpload/components/BulkUploadAccessLayout";

const AuthenticatedRoutes = () => {
    let configuredFeatures = [];
    configuredFeatures.push(
        <React.Fragment key={"dashboard"}>
            <Route path={`/dashboard`} element={<DashboardPage/>}/>
        </React.Fragment>,
        <React.Fragment key={"sales"}>
            <Route path="/sales" element={<SalesInvoiceReadLayout/>}>
                <Route
                    index
                    element={<DocumentListPage isPurchase={false}/>}
                />
                <Route path="invoices" element={<SalesInvoiceReadLayout/>}>
                    <Route path="create" element={<CreateInvoicePage isPurchase={false}/>}/>
                    <Route path=":document_id/resubmit" element={<ResubmitInvoicePage isPurchase={false}/>}/>
                    <Route path=":document_id" element={<InvoiceDetailsPage isPurchase={false}/>}/>
                </Route>
                <Route path="credit-notes" element={<SalesCreditNoteReadLayout/>}>
                    <Route path="create" element={<CreateCreditNotePage isPurchase={false}/>}/>
                    <Route path=":document_id/resubmit" element={<ResubmitCreditNotePage isPurchase={false}/>}/>
                    <Route path=":document_id" element={<CreditNoteDetailsPage isPurchase={false}/>}/>
                </Route>
            </Route>
        </React.Fragment>,
        <React.Fragment key={"purchases"}>

            <Route path="/purchases" element={<PurchaseDocumentsAccessLayout/>}>
                <Route
                    index
                    element={<DocumentListPage isPurchase={true}/>}
                />
                <Route path="invoices" element={<PurchaseInvoiceReadLayout/>}>
                    <Route path="create" element={<CreateInvoicePage isPurchase/>}/>
                    <Route path=":document_id/resubmit" element={<ResubmitInvoicePage isPurchase/>}/>
                    <Route path=":document_id" element={<InvoiceDetailsPage isPurchase/>}/>
                </Route>
                <Route path="credit-notes" element={<PurchaseCreditNoteReadLayout/>}>
                    <Route path="create" element={<CreateCreditNotePage isPurchase/>}/>
                    <Route path=":document_id/resubmit" element={<ResubmitCreditNotePage isPurchase/>}/>
                    <Route path=":document_id" element={<CreditNoteDetailsPage isPurchase/>}/>
                </Route>
            </Route>
        </React.Fragment>,

        <React.Fragment key={"business-profiles"}>
            <Route path="/business-profiles" element={<BusinessProfileAccessLayout/>}>
                <Route
                    index
                    element={<BusinessProfileListPage/>}
                />
                <Route
                    path={`create`}
                    element={<CreateBusinessProfilePage/>}
                />
                <Route
                    path={`:profile_id`}
                    element={<BusinessProfileDetailsPage/>}
                />
                <Route
                    path={`:profile_id/edit`}
                    element={<EditBusinessProfilePage/>}
                />
            </Route>
        </React.Fragment>,

        <React.Fragment key={"customers"}>

            <Route path="/customers" element={<CustomerAccessLayout/>}>
                <Route index element={<CustomerListPage/>}/>
                <Route
                    path={`:profile_id`}
                    element={<CustomerDetailsPage/>}
                />
                <Route
                    path={`:profile_id/edit`}
                    element={<EditCustomerPage/>}
                />
                <Route path={`create`} element={<CreateCustomersPage/>}/>
            </Route>
        </React.Fragment>,

        <React.Fragment key={"products"}>
            <Route path={`/products`} element={<ProductAccessLayout/>}>
                <Route index element={<ProductListPage/>}/>
            </Route>
        </React.Fragment>,

        <React.Fragment key={"suppliers"}>

            <Route path="/suppliers" element={<SupplierAccessLayout/>}>
                <Route index element={<SupplierListPage/>}/>
                <Route
                    path={`:profile_id`}
                    element={<SupplierDetailsPage/>}
                />
                <Route
                    path={`:profile_id/edit`}
                    element={<EditSupplierPage/>}
                />
                <Route path={`create`} element={<CreateSuppliersPage/>}/>
            </Route>
        </React.Fragment>,

        <React.Fragment key={"settings"}>
            <Route path={`/settings`} element={<SettingsPage/>}/>
        </React.Fragment>,

        <React.Fragment key={"reporting-reconciliation"}>
            <Route path="reporting-reconciliation/document-report" element={<DocumentReportAccessLayout />}>
                <Route index element={<DocumentReportPage />} />
            </Route>
            <Route path={`reporting-reconciliation/vat-returns`} element={<VATReportAccessLayout />}>
                <Route index element={<VATReportPage />} />
            </Route>
        </React.Fragment>,

        <React.Fragment key={"bulk-upload"}>
            <Route path={`/bulk-upload`} element={<BulkUploadAccessLayout/>}>
                <Route index element={<BulkUploadListPage/>}/>
            </Route>
        </React.Fragment>,
    );
    return configuredFeatures;
};
export default AuthenticatedRoutes;
